import { useEffect,  useState } from "react"
import axios from "src/shared/axios"

function useIsAuthed() {
  const [isAuthed, setIsAuthed] = useState(true)

  useEffect(() => {
    axios.interceptors.response.use(
      function (response) {
        setIsAuthed(true)
        return response
      },
      function (error) {
        if (error.response.status === 401) setIsAuthed(false)
        return Promise.reject(error)
      }
    ),
      []
  })

  return isAuthed
}

export default useIsAuthed
